const TableMixin = {
	props: {
		/*一下为base table可设置属性*/
		data: {type: Array, default: () => []},         //显示的数据数组
		fixedRowData: {type: Array},                    //固定在顶部的的行数据
		rowNum: {type: Number, default: 10},            //显示的行数，超过则会出现滚动条
		rowHeight: {type: Number, default: 40},         //行高
		headRowHeight: {type: Number, default: 40},     //表头标题行显示高度
		noHeader: {type: Boolean},                      //不显示表头
		fastRender: {type: Boolean},                    //快速渲染模式，启用后渲染速度加快，编辑功能将无法使用，常用语不可编辑并显示大量数据的列表
		columnFilter: {type: Boolean},                  //是否启用列筛选功能，启用之后，列标题位置会出现一个筛选图标，点击会打开筛选对话框
		editableFunc: {type: Function},					//统一的动态编辑函数控制，与列的editableFunc功能一致，相当于给每个列加上了这个属性
		requiredFunc: {type: Function},					//统一的动态必填函数控制，与列的requiredFunc功能一致，相当于给每个列加上了这个属性
		/*以下为base table不可设置属性*/
		tableData: {},                                  //编辑数据数组
		headColumns: {type: Array},                     //渲染表格头列信息数组
		bodyColumns: {type: Array},                     //渲染表体列信息数组
		fixedExist: {type: Object},                     //固定列是否存在
		fixed: {type: String, default: 'center'},       //固定表格的位置:left,center,right
		hostWidth: {type: Number},                      //宿主宽度
		sortField: {type: String},                      //排序字段
		sortDesc: {type: Boolean, default: true},       //先序降序
		defaultEnableEditable: {type: Boolean},         //默认情况下可编辑
		editSourceRow: {type: Boolean},                 //是否直接编辑原始数据
		disabledBodyScroll: {type: Boolean},            //禁用表体滚动
	},
}

export {
	TableMixin,
}
